import React from 'react'

import { REPEAT_OPTIONS } from '../../helpers'
import { COLOR } from '../../themes'
import { StyleRepeatOptionsView } from './styles'

const RepeatOptionsView = (props) => {
  const { language, selectedKey, onSelected, colorTheme } = props

  const renderItem = (data, language) => {
    return data.map((item) => 
      {
        const isSelected = selectedKey === item.key
        const selectedColor = colorTheme || COLOR.GOLD_1
        const color = isSelected ? selectedColor : COLOR.WHITE

        return (
          <div key={item.key} className='radio-layout' onClick={() => onSelected(item.key)}>
            <input
              style={{ color }}
              type='radio'
              value={item.key}
              checked={isSelected}
              readOnly
            />
            <label className='radio-option'>{item[language]}</label>
          </div>
        )
      }
    )
  }

  return (
    <StyleRepeatOptionsView colorTheme={colorTheme}>
      {renderItem(REPEAT_OPTIONS, language)}
    </StyleRepeatOptionsView>
  )
}

export default RepeatOptionsView
